"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTranslationsFeature = exports.getConfigTranslationsLoaded = exports.getTranslationsLoaded = exports.translate = exports.initConfigWebAndOwnTranslations = exports.initTranslationsWithInitialTranslationsAndConfig = exports.initConfigAndTranslations = exports.Translator = exports.initTranslationsWithStaticTranslations = exports.translateToComponent = exports.TranslateText = void 0;
__exportStar(require("./types"), exports);
const features_1 = require("../features");
var translateText_1 = require("./translateText");
Object.defineProperty(exports, "TranslateText", { enumerable: true, get: function () { return translateText_1.TranslateText; } });
var translationToReactComponent_1 = require("./translationToReactComponent");
Object.defineProperty(exports, "translateToComponent", { enumerable: true, get: function () { return translationToReactComponent_1.translateToComponent; } });
var features_2 = require("../features");
Object.defineProperty(exports, "initTranslationsWithStaticTranslations", { enumerable: true, get: function () { return features_2.initTranslationsWithStaticTranslations; } });
let translator;
let translations;
let configTranslations;
var features_3 = require("../features");
Object.defineProperty(exports, "Translator", { enumerable: true, get: function () { return features_3.Translator; } });
const initConfigAndTranslations = async (api, params) => {
    const allTranslations = await (0, features_1.initConfigAndTranslations)(api, params);
    translator = allTranslations.translator;
    translations = allTranslations.translations;
    configTranslations = allTranslations.configTranslations;
    return allTranslations?.translations;
};
exports.initConfigAndTranslations = initConfigAndTranslations;
const initTranslationsWithInitialTranslationsAndConfig = async (api, params, initialTranslations, newConfigTranslations) => {
    const allTranslations = await (0, features_1.initTranslationsWithInitialTranslationsAndConfig)(api, params, initialTranslations, newConfigTranslations);
    translator = allTranslations.translator;
    translations = allTranslations.translations;
    configTranslations = allTranslations.configTranslations;
    return allTranslations.translations;
};
exports.initTranslationsWithInitialTranslationsAndConfig = initTranslationsWithInitialTranslationsAndConfig;
const initConfigWebAndOwnTranslations = async (api, params) => {
    const allTranslations = await (0, features_1.initConfigWebAndOwnTranslations)(api, params);
    translator = allTranslations.translator;
    translations = allTranslations.translations;
    configTranslations = allTranslations.configTranslations;
    return allTranslations?.translations;
};
exports.initConfigWebAndOwnTranslations = initConfigWebAndOwnTranslations;
const translate = (key, values) => {
    if (!translator) {
        throw new Error('Should initialize translations before use it. Use initTranslations');
    }
    return (0, features_1.translate)(translator, key, values);
};
exports.translate = translate;
const getTranslationsLoaded = () => {
    if (!translations) {
        throw new Error('Translations not loaded');
    }
    return translations;
};
exports.getTranslationsLoaded = getTranslationsLoaded;
const getConfigTranslationsLoaded = () => {
    if (!configTranslations) {
        throw new Error('Config Translations not loaded');
    }
    return configTranslations;
};
exports.getConfigTranslationsLoaded = getConfigTranslationsLoaded;
const setTranslationsFeature = (_translator) => {
    translator = _translator;
};
exports.setTranslationsFeature = setTranslationsFeature;
//# sourceMappingURL=translations.js.map